'use client';

import {  X } from 'lucide-react';
import { useState } from 'react';
import { sprinkles } from '@/style/landingPage/theme.css';
import * as styles from '@/style/landingPage/styles.css';
import Link from 'next/link'
import SquareTradeLogo from '@/components/LandingPage/SquareTradeLogo';


export default function TopNav()  {
  const [sidePanelActive, setSidePanelActive] = useState(false)


return (
<>
<nav className={styles.navBar} id="#top">
  <div className={`${styles.container} ${sprinkles({ display: 'flex', justifyContent: 'space-between', alignItems: 'center' })}`}>
    <Link href='/squaretrade' className={sprinkles({ display: 'flex', alignItems: 'center', gap: 'md' })}>
      {/* on tablet down 80 x 40*/}
      <SquareTradeLogo cssClass={sprinkles({
        width: { mobile: 'eighty', tablet: 'headerLogoWidth' },
        height: { mobile: 'forty', tablet: 'headerLogoHeight' },
      })} />
    </Link>
    
    {/* Desktop Menu */}
    <div className={sprinkles({ display: { mobile: 'none', tablet: 'flex' }, alignItems: 'center', gap: 'lg' })}>
      <a href="mailto:enquiresAPAC@squaretrade.com" className={styles.menuLinks}>Contact Us</a>
      <span>|</span>
      <Link href="/resources/overview/" className={styles.menuLinks}>Access existing Kingfisher resources</Link>
    </div>

    {/* Mobile Menu Icon */}
    <div className={sprinkles({ display: { mobile: 'block', tablet: 'none' } })}>
      <button className={styles.hamburgerContainer} onClick={() => setSidePanelActive(true)}>
        <span className={styles.hamburgerLine} style={{top: 0}} />
        <span className={styles.hamburgerLine} style={{top: 'calc(50% - 1px)'}} />
        <span className={styles.hamburgerLine} style={{bottom: 0}}/>
      </button>
    </div>
  </div>
</nav>
<aside className={styles.sidePanelNav}
  style={{ transform: `translateX(${sidePanelActive ? '0%' : '100%'})`}}
>
  <header className={styles.sidePanelNavHeader}>
    <button className={styles.sidePanelCloseBtn} onClick={() => setSidePanelActive(false)}>
      <span>close</span>
      <X />
    </button>
  </header>
  <nav className={styles.sidePanelNavMenu}>
    <a href="mailto:enquiresAPAC@squaretrade.com" style={{ borderTop: '1px solid #45BCE5',}} className={styles.sidePanelNavMenuLink}>Contact Us</a>
    <Link href="/resources/overview/" className={styles.sidePanelNavMenuLink}>Access existing Kingfisher resources</Link>
  </nav>
</aside>
</>
)

}